import PrivateRoute, { Router } from "components/app-layout/PrivateRoute";

import BuilderBlocksGrid from "../components/Grid";
import { BuilderBlocksProvider } from "../store";

import BuilderBlocksFormLayout from "./Form";

export default function BuilderBlocksGridLayout() {
  return <BuilderBlocksProvider>
    <BuilderBlocksGrid />
    <Router>
      <PrivateRoute path={["/cms/builder-blocks/add", "/cms/builder-blocks/:id"]} component={BuilderBlocksFormLayout} />
    </Router>
  </BuilderBlocksProvider>;
}
